import api from "../index";

export const CheckLoginUrlApi = (data) => api.post("checkloginurl", data);
export const LoginApi = (data) => api.post("login", data);
export const LoginOtpVeryficationApi = (data) => api.post("emailverification", data);
export const ForgotPasswordLinkApi = (data) => api.post("sendforgotlink", data);
export const ResetPasswordApi = (data) => api.post("resetpassword", data);
export const ResendOtpApi = (data) => api.post("resendotp", data);
export const LogoutApi = () => api.post("logout");
export const SuperAdminLoginApi = (data, headers) => api.post("access-admin-panel", data, headers);
